import { useClerk } from "@clerk/clerk-react";
export function useOrgId() {
    ///Get org id from clerk using the cleark hook
    const { organization } = useClerk();
    return organization?.id;
}
export function useUserId() {
    const { user } = useClerk();
    return user?.id;
}
export function useUniqueId() {
    const orgId = useOrgId();
    return `${orgId}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
export const getSignature = () => {
    return new URLSearchParams(window.location.search).get('sig');
};
// Determine the API URL based on environment
export const getUserId = () => {
    // Access Clerk instance directly from window
    const clerk = window.Clerk;
    return clerk?.user?.id || "external";
};
export const getUserName = () => {
    // Access Clerk instance directly from window
    const clerk = window.Clerk;
    return clerk?.user?.username || "external";
};
export const getOrgId = () => {
    // Access Clerk instance directly from window  
    const clerk = window.Clerk;
    return clerk?.organization?.id || "external";
};
export const getToken = async () => {
    try {
        // Access Clerk instance directly from window
        const clerk = window.Clerk;
        if (clerk?.session) {
            return await clerk.session.getToken();
        }
        return "external";
    }
    catch (error) {
        console.error('Error getting Clerk token:', error);
        return "external";
    }
};
